<script setup>
/**
 * Vinduet der man plukker språk. Hvem som eier valget bestemmer den som
 * bruker komponenten: forelder setter familiens språk under Innstillinger,
 * mens knappen før innlogging setter språket for enheten.
 *
 * Lista er språkene det finnes en ordbok for, kjent på byggetidspunktet - det
 * er ingenting å hente og ingenting å vente på.
 */
import { computed, ref } from 'vue'
import { t } from '../lib/i18n'
import { languageList } from '../lib/languages'
import BaseModal from './BaseModal.vue'

defineProps({
  current: { type: String, default: 'nb' },
  busy: { type: Boolean, default: false },
  error: { type: String, default: '' },
})
defineEmits(['close', 'choose'])

const query = ref('')

// Søk lønner seg først når lista er for lang til å ses under ett.
const searchable = languageList.length > 8

const filtered = computed(() => {
  const q = query.value.trim().toLowerCase()
  if (!q) return languageList
  return languageList.filter((l) =>
    l.name.toLowerCase().includes(q) || l.code.toLowerCase().includes(q))
})
</script>

<template>
  <BaseModal :title="t('Velg språk')" @close="$emit('close')">
    <div class="stack">
      <input v-if="searchable" v-model="query" class="input" :placeholder="t('Søk etter språk …')" autofocus />

      <p v-if="error" class="alert alert--error">{{ t(error) }}</p>

      <ul class="list" style="max-height: 50vh; overflow-y: auto">
        <li v-for="l in filtered" :key="l.code">
          <button class="list-item picker-row" :disabled="busy" @click="$emit('choose', l.code)">
            <span class="grow" style="text-align: left">{{ l.name }}</span>
            <span v-if="l.code === current" class="chip chip--brand">{{ t('valgt') }}</span>
          </button>
        </li>
        <li v-if="!filtered.length" class="hint" style="padding: 12px">
          {{ t('Fant ingen språk som matcher søket.') }}
        </li>
      </ul>
    </div>
  </BaseModal>
</template>

<style scoped>
.picker-row { width: 100%; background: none; border: 0; cursor: pointer; }
</style>
